var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-widget",class:_vm.data.renk},[_c('i',{class:_vm.data.icon}),_vm._v(" "),_c('div',{staticClass:"m-icerik"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.data.sayi)}}),_vm._v(" "),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.data.isim)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dafde5c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pack/Genel/mWidget.vue
// module id = 696
// module chunks = 0